module.exports = __webpack_public_path__ + "img/wlwbyznkzq3.7fedf487.jpg";